/**
 * Data audio analysis mock
 */

// Models
import { IParamGetList } from 'models/UserRequest';

// Utils
import { RowHeader } from 'utils/types';
import { ParamsGetListSetting } from 'utils/constants';

export const headerAudioAnalysis: RowHeader[] = [
  { id: 'id', label: 'No', position: 'center', haveSort: false },
  { id: 'status', label: '利用状況', haveSort: false },
  { id: 'user_company', label: '企業名/団体名' },
  { id: 'user_department', label: '所属' },
  { id: 'user_name', label: '名前' },
  { id: 'user_email', label: 'メールアドレス' },
  { id: 'event_name', label: 'イベント名' },
  { id: 'event_start_date', label: '開催日' },
  { id: 'event_end_date', label: '終了日' },
  { id: 'staff_count', label: '録音者数' },
  { id: 'recordings_count', label: '録音数' },
  { id: 'total_duration', label: '総録音時間' },
];

export const defaultParamsAudioAnalysis: IParamGetList = {
  keyword: '',
  order_by: 'desc',
  sort_name: 'event_start_date',
  page: ParamsGetListSetting.DEFAULT_PAGE as number,
  per_page: ParamsGetListSetting.ROW_PER_PAGE as number,
};
